// import ElementUI from 'element-ui';
import '../public/lib/element-ui/theme/index.css';
// import Vue from 'vue'
import "./style/index.css"
import router from './router'
import store from "./store";
import App from './App.vue'
import common from "./utils/common"
import * as components from "@/components"
import './utils/rem'
import packVariable from "./utils/packVariable";
// 自动滚动
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
// 字体图标
import '@/assets/icon/iconfont.css'



Vue.prototype.$common = common;
Vue.prototype.$COMPANY_NAME = process.env.VUE_APP_COMPANY_NAME;
Vue.prototype.$ENV = packVariable[process.env.VUE_APP_COMPANY_NAME];
Vue.prototype.$isMobile = document.body.getBoundingClientRect().width <= 992

Object.keys(components).forEach(key => {
  Vue.component(key, components[key])
})

Vue.config.productionTip = false
// Vue.prototype.$version = 'v6.0.1';

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
